import React, { useState } from "react";
import MainCalculatorsList from "./CountriesMainCalculatorsList/EgyptMainCalculator";
import RelatedLinks from "../RelatedLinks";
import { SecondAds, FirstAds , MobileUnderCalAds } from "../../Ads";
import SharedHelmet from "../Helmet";
const TITLE = "حاسبة فاتورة الكهرباء في مصر - احسب تكلفة استهلاكك الشهري";
const DESCRIPTION =
  "احسب قيمة فاتورة الكهرباء بدقة باستخدام التعريفة الرسمية الجديدة. أدخل استهلاكك واحصل على حساب تفصيلي فوري للشرائح السبع مع رسوم خدمة العملاء - أداة مجانية سهلة الاستخدام";
const KEYWORDS = "حاسبة فاتورة الكهرباء مصر, حساب استهلاك الكهرباء, تعريفة الكهرباء الجديدة, أسعار شرائح الكهرباء, كيلووات ساعة";
const OG_URL =
  "https://do-calculate.com/calculator/ar/countries/EG/calculators-list/electricity-calculator/";
// بيانات الأجهزة المنزلية
const APPLIANCES_DATA = {
  cooling: [
    { name: "مكيف شباك 1.5 حصان", power: 1500, hours: 6, emoji: "❄️" },
    { name: "مكيف سبليت 1.5 حصان", power: 1200, hours: 6, emoji: "🌡️" },
    { name: "مكيف سبليت 2.25 حصان", power: 1800, hours: 6, emoji: "❄️" },
    { name: "مروحة سقف", power: 70, hours: 10, emoji: "🌀" },
    { name: "مروحة عمود", power: 60, hours: 8, emoji: "💨" },
  ],
  heating: [
    { name: "سخان كهرباء 50 لتر", power: 1500, hours: 3, emoji: "💧" },
    { name: "سخان كهرباء 80 لتر", power: 2000, hours: 3, emoji: "💧" },
    { name: "سخان ماء فوري", power: 3000, hours: 1, emoji: "⚡" },
    { name: "دفاية كهربائية", power: 2000, hours: 4, emoji: "🔥" },
  ],
  kitchen: [
    { name: "ثلاجة عادية 12 قدم", power: 120, hours: 24, emoji: "🧊" },
    { name: "ثلاجة نوفروست 16 قدم", power: 180, hours: 24, emoji: "❄️" },
    { name: "فرن كهربائي", power: 2500, hours: 1, emoji: "🍕" },
    { name: "بوتاجاز كهربائي", power: 2000, hours: 1.5, emoji: "🔥" },
    { name: "ميكروويف", power: 1000, hours: 0.5, emoji: "🍲" },
    { name: "غلاية كهربائية", power: 2000, hours: 0.5, emoji: "☕" },
  ],
  laundry: [
    { name: "غسالة أوتوماتيك", power: 500, hours: 1.5, emoji: "👕" },
    { name: "غسالة نصف أوتوماتيك", power: 300, hours: 2, emoji: "🧺" },
    { name: "مكواة", power: 1200, hours: 1, emoji: "👔" },
  ],
  electronics: [
    { name: "تلفزيون LED 43 بوصة", power: 80, hours: 6, emoji: "📺" },
    { name: "تلفزيون 32 بوصة", power: 50, hours: 6, emoji: "📺" },
    { name: "كمبيوتر مكتبي", power: 200, hours: 6, emoji: "🖥️" },
    { name: "لابتوب", power: 60, hours: 5, emoji: "💻" },
    { name: "راوتر إنترنت", power: 10, hours: 24, emoji: "📡" },
    { name: "ريسيفر", power: 20, hours: 6, emoji: "📡" },
  ],
  lighting: [
    { name: "لمبة LED 9 واط", power: 9, hours: 6, emoji: "💡" },
    { name: "لمبة توفير 20 واط", power: 20, hours: 6, emoji: "💡" },
    { name: "لمبة عادية 60 واط", power: 60, hours: 6, emoji: "🔆" },
    { name: "نجفة 5 لمبات", power: 300, hours: 4, emoji: "💎" },
  ]
};
// دالة لحساب رسوم خدمة العملاء حسب الشريحة
const getCustomerServiceFee = (kwh) => {
  if (kwh <= 50) return 1;
  if (kwh <= 100) return 2;
  if (kwh <= 200) return 11;
  if (kwh <= 650) return 15;
  if (kwh <= 1000) return 15;
  return 40;
};
function ElectricityCalculator() {
  const [consumption, setConsumption] = useState("");
  const [meterType, setMeterType] = useState("legal"); // legal or illegal
  const [result, setResult] = useState(null);
  const [error, setError] = useState("");
  const [applianceHours, setApplianceHours] = useState({});
  // التاريخ الحالي
  const today = new Date().toLocaleDateString('ar-EG', {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });
  const calculateBill = () => {
    try {
      setError("");
      const kwh = parseFloat(consumption);
      if (isNaN(kwh) || kwh <= 0) {
        setError("يرجى إدخال قيمة استهلاك صالحة");
        return;
      }
      let totalCost = 0;
      let customerServiceFee = 0;
      let breakdown = [];
      if (meterType === "illegal") {
        // العدادات الكودية المخالفة - تعريفة موحدة
        totalCost = kwh * 2.145; // 214.5 قرش
        customerServiceFee = 0; // لا توجد رسوم خدمة في الوثيقة للعدادات المخالفة
        setResult({
          totalCost,
          customerServiceFee,
          totalWithFees: totalCost + customerServiceFee,
          breakdown: [{
            tier: "تعريفة موحدة (بدون دعم)",
            kwh: kwh,
            rate: 2.145,
            cost: totalCost
          }],
          isIllegal: true
        });
      } else {
        // العدادات القانونية - نظام الشرائح السبع
        // الشريحة الأولى: 0-50 كيلووات @ 0.68 جنيه
        if (kwh <= 50) {
          const tierKwh = kwh;
          const tierCost = tierKwh * 0.68;
          totalCost = tierCost;
          breakdown.push({ tier: "الشريحة الأولى (0-50)", kwh: tierKwh, rate: 0.68, cost: tierCost });
        }
        // الشريحة الثانية: 51-100 كيلووات @ 0.78 جنيه
        else if (kwh <= 100) {
          const tier1Kwh = 50;
          const tier1Cost = tier1Kwh * 0.68;
          const tier2Kwh = kwh - 50;
          const tier2Cost = tier2Kwh * 0.78;
          totalCost = tier1Cost + tier2Cost;
          breakdown.push({ tier: "الشريحة الأولى (0-50)", kwh: tier1Kwh, rate: 0.68, cost: tier1Cost });
          breakdown.push({ tier: "الشريحة الثانية (51-100)", kwh: tier2Kwh, rate: 0.78, cost: tier2Cost });
        }
        // الشريحة الثالثة: 0-200 كيلووات @ 0.95 جنيه
        else if (kwh <= 200) {
          const tierKwh = kwh;
          const tierCost = tierKwh * 0.95;
          totalCost = tierCost;
          breakdown.push({ tier: "الشريحة الثالثة (0-200)", kwh: tierKwh, rate: 0.95, cost: tierCost });
        }
        // الشريحة الرابعة: 201-350 كيلووات @ 1.55 جنيه
        else if (kwh <= 350) {
          const tier3Kwh = 200;
          const tier3Cost = tier3Kwh * 0.95;
          const tier4Kwh = kwh - 200;
          const tier4Cost = tier4Kwh * 1.55;
          totalCost = tier3Cost + tier4Cost;
          breakdown.push({ tier: "الشريحة الثالثة (0-200)", kwh: tier3Kwh, rate: 0.95, cost: tier3Cost });
          breakdown.push({ tier: "الشريحة الرابعة (201-350)", kwh: tier4Kwh, rate: 1.55, cost: tier4Cost });
        }
        // الشريحة الخامسة: 351-650 كيلووات @ 1.95 جنيه
        else if (kwh <= 650) {
          const tier3Kwh = 200;
          const tier3Cost = tier3Kwh * 0.95;
          const tier4Kwh = 150;
          const tier4Cost = tier4Kwh * 1.55;
          const tier5Kwh = kwh - 350;
          const tier5Cost = tier5Kwh * 1.95;
          totalCost = tier3Cost + tier4Cost + tier5Cost;
          breakdown.push({ tier: "الشريحة الثالثة (0-200)", kwh: tier3Kwh, rate: 0.95, cost: tier3Cost });
          breakdown.push({ tier: "الشريحة الرابعة (201-350)", kwh: tier4Kwh, rate: 1.55, cost: tier4Cost });
          breakdown.push({ tier: "الشريحة الخامسة (351-650)", kwh: tier5Kwh, rate: 1.95, cost: tier5Cost });
        }
        // الشريحة السادسة: 651-1000 كيلووات @ 2.10 جنيه
        else if (kwh <= 1000) {
          const tier3Kwh = 200;
          const tier3Cost = tier3Kwh * 0.95;
          const tier4Kwh = 150;
          const tier4Cost = tier4Kwh * 1.55;
          const tier5Kwh = 300;
          const tier5Cost = tier5Kwh * 1.95;
          const tier6Kwh = kwh - 650;
          const tier6Cost = tier6Kwh * 2.10;
          totalCost = tier3Cost + tier4Cost + tier5Cost + tier6Cost;
          breakdown.push({ tier: "الشريحة الثالثة (0-200)", kwh: tier3Kwh, rate: 0.95, cost: tier3Cost });
          breakdown.push({ tier: "الشريحة الرابعة (201-350)", kwh: tier4Kwh, rate: 1.55, cost: tier4Cost });
          breakdown.push({ tier: "الشريحة الخامسة (351-650)", kwh: tier5Kwh, rate: 1.95, cost: tier5Cost });
          breakdown.push({ tier: "الشريحة السادسة (651-1000)", kwh: tier6Kwh, rate: 2.10, cost: tier6Cost });
        }
        // الشريحة السابعة: أكثر من 1000 كيلووات @ 2.30 جنيه (بدون دعم)
        else {
          const tierKwh = kwh;
          const tierCost = tierKwh * 2.30;
          totalCost = tierCost;
          breakdown.push({ tier: "الشريحة السابعة (+1000 - بدون دعم)", kwh: tierKwh, rate: 2.30, cost: tierCost });
        }
        customerServiceFee = getCustomerServiceFee(kwh);
        setResult({
          totalCost,
          customerServiceFee,
          totalWithFees: totalCost + customerServiceFee,
          breakdown,
          isIllegal: false
        });
      }
    } catch (error) {
      setError("حدث خطأ في الحساب");
    }
  };
  const updateApplianceHours = (category, name, hours) => {
    const id = `${category}-${name}`;
    const updatedHours = {
      ...applianceHours,
      [id]: parseFloat(hours) || 0
    };
    setApplianceHours(updatedHours);
    let total = 0;
    Object.entries(APPLIANCES_DATA).forEach(([cat, appliances]) => {
      appliances.forEach(app => {
        const appId = `${cat}-${app.name}`;
        const hrs = updatedHours[appId] || 0;
        if (hrs > 0) {
          const daily = (app.power * hrs) / 1000;
          total += daily * 30;
        }
      });
    });
    if (total > 0) {
      setConsumption(total.toFixed(1));
    }
  };
  return (
    <div className="rtl">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="text-white text-center"
            style={{ height: "50px", display: "flex", alignItems: "center", justifyContent: "center", backgroundColor: "#006c35" }}
          >
            <h1 style={{ fontSize: "17px", margin: 0 }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div className="p-3">
                <p>
                  احسب فاتورة الكهرباء بدقة وفقاً للتعريفة الرسمية المعتمدة من وزارة الكهرباء
                  والطاقة المتجددة. أدخل استهلاكك الشهري بالكيلووات ساعة واحصل على تفاصيل
                  كاملة للفاتورة مع توزيع التكلفة على الشرائح السبع بالإضافة إلى رسوم خدمة العملاء.
                </p>
                <p>
                  تعتمد مصر نظام تسعير متدرج للكهرباء لتحقيق العدالة الاجتماعية وترشيد الاستهلاك.
                  النظام يبدأ من 68 قرشاً للشريحة الأولى حتى 50 كيلووات، ويصل إلى 2.30 جنيه
                  للاستهلاك الذي يتجاوز 1000 كيلووات شهرياً والذي لا يحصل على أي دعم.
                </p>
                <p>
                  استخدم الأداة لحساب فاتورتك الشهرية وفهم توزيع التكاليف، أو احسب استهلاك
                  أجهزتك المنزلية من خلال قسم الأجهزة أدناه للحصول على صورة واضحة عن أكثر
                  الأجهزة استهلاكاً وكيفية تخفيض الفاتورة.
                </p>
                <hr />
              </div>
            </div>
             <MobileUnderCalAds />
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 text-white" style={{ backgroundColor: "#006c35" }}>
                  <h2 style={{ fontSize: "16px", margin: 0 }}>{TITLE}</h2>
                </div>
                <div className="bg-warning text-black text-center p-2">
                  <u><b>ملاحظة هامة</b>:</u>{" "}
                  <b>
                    تاريخ آخر تحديث: <time dateTime={new Date().toISOString().split('T')[0]}>{today}</time>
                  </b>
                </div>
                <div className="p-3">
                  <div className="form-group mb-3">
                    <label><strong>نوع العداد:</strong></label>
                    <select
                      className="form-control"
                      value={meterType}
                      onChange={(e) => setMeterType(e.target.value)}
                    >
                      <option value="legal">📊 عداد قانوني (مسبق الدفع / كودي قانوني / ميكانيكي)</option>
                      <option value="illegal">⚠️ عداد كودي مخالف (للعقارات المخالفة)</option>
                    </select>
                  </div>
                  <div className="form-group mb-3">
                    <label htmlFor="consumption"><strong>الاستهلاك الشهري (كيلووات ساعة):</strong></label>
                    <input
                      id="consumption"
                      type="number"
                      value={consumption}
                      onChange={(e) => setConsumption(e.target.value)}
                      className="form-control mb-2"
                      placeholder="مثال: 250"
                    />
                  </div>
                  {meterType === "legal" && (
                    <div className="alert alert-info">
                      <strong>📊 نظام الشرائح السبع:</strong>
                      <ul style={{ marginBottom: 0, marginTop: "10px", paddingRight: "20px", fontSize: "13px" }}>
                        <li>الشريحة الأولى (0-50): <strong>68 قرش</strong></li>
                        <li>الشريحة الثانية (51-100): <strong>78 قرش</strong></li>
                        <li>الشريحة الثالثة (0-200): <strong>95 قرش</strong></li>
                        <li>الشريحة الرابعة (201-350): <strong>155 قرش</strong></li>
                        <li>الشريحة الخامسة (351-650): <strong>195 قرش</strong></li>
                        <li>الشريحة السادسة (651-1000): <strong>210 قرش</strong></li>
                        <li>الشريحة السابعة (+1000): <strong>230 قرش (بدون دعم)</strong></li>
                      </ul>
                    </div>
                  )}
                  {meterType === "illegal" && (
                    <div className="alert alert-danger">
                      <strong>⚠️ تعريفة العدادات المخالفة:</strong>
                      <p style={{ marginBottom: 0, marginTop: "10px" }}>
                        حسب قرار جهاز تنظيم الكهرباء رقم 142 لسنة 2024، العدادات الكودية
                        للعقارات المخالفة تُحاسب بتعريفة موحدة <strong>214.5 قرش/كيلووات</strong>
                        من أول كيلووات بدون أي شرائح أو دعم.
                      </p>
                    </div>
                  )}
                  <br />
                  <button
                    className="text-white"
                    style={{ fontSize: "20px", marginLeft: "10px", padding: "10px 30px", border: "none", borderRadius: "5px", backgroundColor: "#006c35" }}
                    onClick={calculateBill}
                  >
                    احسب                  </button>
                </div>
                { error !== "" ? (
                  <p className="p-3 mb-2 bg-warning text-white">خطأ: {error}</p>
                ) : (
                  result !== null && (
                    <div className="p-3 mb-2 text-white" style={{ backgroundColor: "#006c35" }}>
                      <p style={{ fontSize: "18px", marginBottom: "10px" }}>
                        <strong>💰 قيمة الاستهلاك: {result.totalCost.toFixed(2)} جنيه</strong>
                      </p>
                      {!result.isIllegal && result.customerServiceFee > 0 && (
                        <p style={{ fontSize: "16px", marginBottom: "10px" }}>
                          <strong>🔧 رسوم خدمة عملاء: {result.customerServiceFee.toFixed(2)} جنيه</strong>
                        </p>
                      )}
                      <p style={{ fontSize: "19px", marginBottom: "10px", borderTop: "2px solid white", paddingTop: "10px" }}>
                        <strong>💵 إجمالي الفاتورة: {result.totalWithFees.toFixed(2)} جنيه</strong>
                      </p>
                      {!result.isIllegal && (
                        <div style={{ fontSize: "14px", marginTop: "15px", borderTop: "1px solid white", paddingTop: "10px" }}>
                          <strong>تفاصيل الحساب:</strong>
                          {result.breakdown.map((item, index) => (
                            <p key={index} style={{ marginBottom: "5px", marginTop: "8px" }}>
                              {item.tier}: {item.kwh.toFixed(0)} كيلووات × {item.rate.toFixed(2)} = {item.cost.toFixed(2)} جنيه
                            </p>
                          ))}
                        </div>
                      )}
                      {result.isIllegal && (
                        <div style={{ fontSize: "14px", marginTop: "15px" }}>
                          <p>
                            تعريفة موحدة: {result.breakdown[0].kwh.toFixed(0)} كيلووات × {result.breakdown[0].rate.toFixed(2)} = {result.breakdown[0].cost.toFixed(2)} جنيه
                          </p>
                        </div>
                      )}
                      <div className="alert alert-warning mt-3" style={{ fontSize: "13px" }}>
                        <strong>⚠️ تنبيه:</strong> يجب دفع الفاتورة خلال شهر من تاريخ إصدارها لتجنب غرامة تأخير 7% من قيمة الفاتورة
                      </div>
                    </div>
                  )
                )}
              </div>
              <div className="col-sm-12 col-md-5">
                {/* جدول الأسعار الرسمية */}
                <div className="calculatorStyle">
                  <div className="p-3 mb-2 text-white" style={{ backgroundColor: "#006c35" }}>
                    <h3 style={{ fontSize: "16px", margin: 0 }}>📋 جدول الأسعار الرسمية</h3>
                  </div>
                  <div className="p-3">
                    <div className="mb-3">
                      <strong>🏠 العدادات القانونية</strong>
                      <table className="table table-sm mt-2 table-bordered" style={{ fontSize: "12px" }}>
                        <thead className="table-light">
                          <tr>
                            <th>الشريحة</th>
                            <th>السعر</th>
                            <th>خدمة عملاء</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>0-50 كيلووات</td>
                            <td><strong>68 قرش</strong></td>
                            <td>1 جنيه</td>
                          </tr>
                          <tr>
                            <td>51-100</td>
                            <td><strong>78 قرش</strong></td>
                            <td>2 جنيه</td>
                          </tr>
                          <tr>
                            <td>0-200</td>
                            <td><strong>95 قرش</strong></td>
                            <td>11 جنيه</td>
                          </tr>
                          <tr>
                            <td>201-350</td>
                            <td><strong>155 قرش</strong></td>
                            <td>15 جنيه</td>
                          </tr>
                          <tr>
                            <td>351-650</td>
                            <td><strong>195 قرش</strong></td>
                            <td>15 جنيه</td>
                          </tr>
                          <tr>
                            <td>651-1000</td>
                            <td><strong>210 قرش</strong></td>
                            <td>15 جنيه</td>
                          </tr>
                          <tr>
                            <td>+1000</td>
                            <td><strong>230 قرش</strong></td>
                            <td>40 جنيه</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <div>
                      <strong>⚠️ العدادات المخالفة</strong>
                      <table className="table table-sm mt-2 table-bordered" style={{ fontSize: "13px" }}>
                        <tbody>
                          <tr>
                            <td>جميع الاستهلاك</td>
                            <td><strong>214.5 قرش</strong></td>
                          </tr>
                        </tbody>
                      </table>
                      <small className="text-muted">
                        * حسب قرار جهاز تنظيم الكهرباء رقم 142 لسنة 2024
                      </small>
                    </div>
                  </div>
                </div>
                <br />
                {/* أمثلة سريعة */}
                <div className="calculatorStyle">
                  <div className="p-3 mb-2 text-white" style={{ backgroundColor: "#006c35" }}>
                    <h3 style={{ fontSize: "16px", margin: 0 }}>🧮 أمثلة سريعة</h3>
                  </div>
                  <div className="p-3">
                    <div className="mb-2 p-2" style={{ border: "2px solid #006c35", borderRadius: "5px" }}>
                      <strong>50 كيلووات:</strong>
                      <br />
                      50 × 0.68 = 34 جنيه + 1 رسوم = <strong>35 جنيه</strong>
                    </div>
                    <div className="mb-2 p-2" style={{ border: "2px solid #006c35", borderRadius: "5px" }}>
                      <strong>100 كيلووات:</strong>
                      <br />
                      (50 × 0.68) + (50 × 0.78) + 2 = <strong>75 جنيه</strong>
                    </div>
                    <div className="mb-2 p-2" style={{ border: "2px solid #006c35", borderRadius: "5px" }}>
                      <strong>200 كيلووات:</strong>
                      <br />
                      200 × 0.95 = 190 + 11 = <strong>201 جنيه</strong>
                    </div>
                    <div className="p-2" style={{ border: "2px solid #006c35", borderRadius: "5px" }}>
                      <strong>500 كيلووات:</strong>
                      <br />
                      (200×0.95)+(150×1.55)+(150×1.95)+15 = <strong>717.5 جنيه</strong>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <hr />
            {/* قسم حساب الاستهلاك من الأجهزة */}
            <div className="row">
              <div className="col-sm-12 col-md-12 calculatorStyle">
                <div className="p-3 mb-2 text-white" style={{ backgroundColor: "#006c35" }}>
                  <h2 style={{ fontSize: "16px", margin: 0 }}>
                    🔌 احسب استهلاكك من أجهزتك المنزلية
                  </h2>
                </div>
                <div className="p-3">
                  <p>حدد ساعات تشغيل أجهزتك اليومية وسيتم حساب الاستهلاك والتكلفة تلقائياً</p>
                  {Object.entries(APPLIANCES_DATA).map(([category, appliances]) => (
                    <div key={category} className="mb-4">
                      <h3 className="bg-success text-white text-center">
                        {category === 'cooling' && '❄️ التبريد والتهوية'}
                        {category === 'heating' && '🔥 التسخين والتدفئة'}
                        {category === 'kitchen' && '🍳 أجهزة المطبخ'}
                        {category === 'laundry' && '🧺 الغسيل والعناية'}
                        {category === 'electronics' && '📺 الإلكترونيات'}
                        {category === 'lighting' && '💡 الإضاءة'}
                      </h3>
                      <div className="row">
                        {appliances.map((app) => {
                          const id = `${category}-${app.name}`;
                          const hours = applianceHours[id] || 0;
                          const monthly = hours > 0 ? ((app.power * hours) / 1000) * 30 : 0;
                          // حساب التكلفة التقريبية (باستخدام معدل وسطي)
                          let estimatedCost = 0;
                          if (monthly > 0) {
                            if (monthly <= 50) estimatedCost = monthly * 0.68;
                            else if (monthly <= 200) estimatedCost = monthly * 0.95;
                            else if (monthly <= 350) estimatedCost = (200 * 0.95) + ((monthly - 200) * 1.55);
                            else estimatedCost = (200 * 0.95) + (150 * 1.55) + ((monthly - 350) * 1.95);
                          }
                          return (
                            <div className="col-sm-12 col-md-4 mb-3" key={id}>
                              <div style={{ minHeight: "180px", border: "2px solid #006c35", borderRadius: "5px", overflow: "hidden" }}>
                                <div className="p-2 mb-2 text-white" style={{ backgroundColor: "#006c35" }}>
                                  <strong style={{ fontSize: "14px" }}>{app.emoji} {app.name}</strong>
                                </div>
                                <div className="p-3">
                                  <small className="text-muted d-block mb-2">
                                    القدرة: {app.power} واط
                                  </small>
                                  <div className="form-group mb-2">
                                    <label style={{ fontSize: "12px" }}>ساعات التشغيل يومياً:</label>
                                    <input
                                      type="number"
                                      className="form-control form-control-sm"
                                      value={hours || ''}
                                      onChange={(e) => updateApplianceHours(category, app.name, e.target.value)}
                                      placeholder={`مثال: ${app.hours}`}
                                      min="0"
                                      step="0.5"
                                    />
                                  </div>
                                  {hours > 0 && (
                                    <div className="d-block" style={{ color: "#006c35" }}>
                                      <small>
                                        الاستهلاك: <strong>{monthly.toFixed(1)} كيلووات/شهر</strong>
                                      </small>
                                      <br />
                                      <small>
                                        التكلفة التقريبية: <strong>{estimatedCost.toFixed(2)} جنيه</strong>
                                      </small>
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
            <hr />
            {/* نصائح التوفير */}
            <div className="row">
              <div className="col-sm-12 col-md-12 calculatorStyle">
                <div className="p-3 mb-2 text-white" style={{ backgroundColor: "#006c35" }}>
                  <h2 style={{ fontSize: "16px", margin: 0 }}>💡 نصائح لتوفير الكهرباء والبقاء في الشرائح المدعومة</h2>
                </div>
                <div className="p-3">
                  <div className="row">
                    <div className="col-sm-12 col-md-6">
                      <div style={{ border: "2px solid #006c35", borderRadius: "5px", overflow: "hidden" }}>
                        <div className="p-2 text-white" style={{ backgroundColor: "#006c35" }}>
                          <strong style={{ fontSize: "14px" }}>حافظ على استهلاكك أقل من 200 كيلووات</strong>
                        </div>
                        <div className="p-3">
                          <p style={{ fontSize: "14px", marginBottom: 0 }}>
                            البقاء في الشريحة الثالثة (95 قرش) يوفر عليك الكثير. بعد 200 كيلووات السعر يقفز لـ 155 قرش!
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="col-sm-12 col-md-6">
                      <div style={{ border: "2px solid #006c35", borderRadius: "5px", overflow: "hidden" }}>
                        <div className="p-2 text-white" style={{ backgroundColor: "#006c35" }}>
                          <strong style={{ fontSize: "14px" }}>قلل استخدام المكيف في الصيف</strong>
                        </div>
                        <div className="p-3">
                          <p style={{ fontSize: "14px", marginBottom: 0 }}>
                            المكيف يستهلك 200-300 كيلووات شهرياً. استخدم المراوح وشغل المكيف 4-5 ساعات فقط
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="col-sm-12 col-md-6">
                      <div style={{ border: "2px solid #006c35", borderRadius: "5px", overflow: "hidden" }}>
                        <div className="p-2 text-white" style={{ backgroundColor: "#006c35" }}>
                          <strong style={{ fontSize: "14px" }}>استخدم سخان غاز بدل الكهرباء</strong>
                        </div>
                        <div className="p-3">
                          <p style={{ fontSize: "14px", marginBottom: 0 }}>
                            السخان الكهربائي يستهلك 120-180 كيلووات شهرياً. سخان الغاز أوفر بكثير
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="col-sm-12 col-md-6">
                      <div style={{ border: "2px solid #006c35", borderRadius: "5px", overflow: "hidden" }}>
                        <div className="p-2 text-white" style={{ backgroundColor: "#006c35" }}>
                          <strong style={{ fontSize: "14px" }}>افصل الأجهزة الكهربائية تماماً</strong>
                        </div>
                        <div className="p-3">
                          <p style={{ fontSize: "14px", marginBottom: 0 }}>
                            الأجهزة في وضع الاستعداد تستهلك كهرباء! افصل الشواحن والريسيفر والتلفزيون
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="col-sm-12 col-md-6">
                      <div style={{ border: "2px solid #006c35", borderRadius: "5px", overflow: "hidden" }}>
                        <div className="p-2 text-white" style={{ backgroundColor: "#006c35" }}>
                          <strong style={{ fontSize: "14px" }}>استبدل اللمبات بـ LED</strong>
                        </div>
                        <div className="p-3">
                          <p style={{ fontSize: "14px", marginBottom: 0 }}>
                            لمبة LED 9 واط تعطي إضاءة لمبة عادية 60 واط - توفير 85% من استهلاك الإنارة
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="col-sm-12 col-md-6">
                      <div style={{ border: "2px solid #006c35", borderRadius: "5px", overflow: "hidden" }}>
                        <div className="p-2 text-white" style={{ backgroundColor: "#006c35" }}>
                          <strong style={{ fontSize: "14px" }}>نظف فلاتر المكيف والثلاجة</strong>
                        </div>
                        <div className="p-3">
                          <p style={{ fontSize: "14px", marginBottom: 0 }}>
                            الفلاتر المتسخة تزيد الاستهلاك 20-30%. نظف فلاتر المكيف كل أسبوعين
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="col-sm-12 col-md-6">
                      <div style={{ border: "2px solid #006c35", borderRadius: "5px", overflow: "hidden" }}>
                        <div className="p-2 text-white" style={{ backgroundColor: "#006c35" }}>
                          <strong style={{ fontSize: "14px" }}>استخدم الغسالة بحمولة كاملة</strong>
                        </div>
                        <div className="p-3">
                          <p style={{ fontSize: "14px", marginBottom: 0 }}>
                            تشغيل الغسالة نصف ممتلئة يهدر الكهرباء. انتظر حتى تمتلئ تماماً
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="col-sm-12 col-md-6">
                      <div style={{ border: "2px solid #006c35", borderRadius: "5px", overflow: "hidden" }}>
                        <div className="p-2 text-white" style={{ backgroundColor: "#006c35" }}>
                          <strong style={{ fontSize: "14px" }}>تجنب الشريحة السابعة (+1000)</strong>
                        </div>
                        <div className="p-3">
                          <p style={{ fontSize: "14px", marginBottom: 0 }}>
                            الشريحة السابعة بدون دعم (230 قرش). استهلاك 1000 كيلووات = 2340 جنيه!
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList />
          <br />
        </div>
      </div>
      {/* الأسئلة الشائعة */}
      <div className="row" style={{ height: "auto" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">كيف يتم احتساب فاتورة الكهرباء في مصر؟</div>
              <div className="info-section-body">
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>نظام الشرائح السبع</h2>
                  </u>
                  <p>
                    تعتمد مصر نظام تسعير متدرج مكون من 7 شرائح للقطاع المنزلي، بالإضافة إلى
                    رسوم خدمة عملاء تختلف حسب حجم الاستهلاك. النظام يبدأ من 68 قرش للكيلووات
                    في الشريحة الأولى ويصل إلى 230 قرش للاستهلاك الذي يتجاوز 1000 كيلووات.
                  </p>
                  <br />
                </div>
                <hr />
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>مثال حسابي</h2>
                  </u>
                  <p>
                    إذا كان استهلاكك 250 كيلووات/ساعة شهرياً:
                  </p>
                  <div className="p-3 mb-2 bg-info text-black">
                    الشريحة الثالثة (0-200): 200 × 0.95 = 190 جنيه
                    <br />
                    الشريحة الرابعة (201-350): 50 × 1.55 = 77.5 جنيه
                    <br />
                    رسوم خدمة عملاء: 15 جنيه
                    <br />
                    <strong>الإجمالي: 282.5 جنيه</strong>
                  </div>
                  <br />
                </div>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">ما الفرق بين الشريحة الأولى والثانية والثالثة؟</div>
              <div className="info-section-body">
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>نظام محاسبة خاص</h2>
                  </u>
                  <p>
                    الشرائح الثلاث الأولى لها نظام محاسبة مختلف:
                    <br />
                    • الشريحة الأولى (0-50): تُحاسب بـ 68 قرش فقط إذا كان استهلاكك لا يتجاوز 50
                    <br />
                    • الشريحة الثانية (51-100): تُحاسب جزئياً - أول 50 بسعر الشريحة الأولى والباقي بـ 78 قرش
                    <br />
                    • الشريحة الثالثة (0-200): إذا تجاوزت 100 كيلووات، يُحتسب كامل الاستهلاك بـ 95 قرش
                  </p>
                  <br />
                </div>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">ما هي رسوم خدمة العملاء؟</div>
              <div className="info-section-body">
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>رسوم إضافية على الفاتورة</h2>
                  </u>
                  <p>
                    رسوم خدمة العملاء تختلف حسب الاستهلاك:
                  </p>
                  <div className="p-3 mb-2 bg-info text-black">
                    • 0-50 كيلووات: 1 جنيه
                    <br />
                    • 51-100 كيلووات: 2 جنيه
                    <br />
                    • 0-200 كيلووات: 11 جنيه
                    <br />
                    • 201-1000 كيلووات: 15 جنيه
                    <br />
                    • أكثر من 1000: 40 جنيه
                  </div>
                  <br />
                </div>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">ما هي تعريفة العدادات الكودية المخالفة؟</div>
              <div className="info-section-body">
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>قرار جهاز تنظيم الكهرباء رقم 142 لسنة 2024</h2>
                  </u>
                  <p>
                    العدادات الكودية التي يتم تركيبها للعقارات والوحدات المخالفة لا تستفيد من
                    نظام الشرائح، ويتم محاسبتها بتعريفة موحدة ثابتة بسعر <strong>214.5 قرش</strong>
                    لكل كيلووات ساعة من أول كيلووات بدون أي دعم.
                  </p>
                  <div className="p-3 mb-2 bg-warning text-black">
                    <strong>مثال:</strong> استهلاك 300 كيلووات في عداد مخالف = 300 × 2.145 = 643.5 جنيه
                    <br />
                    بينما نفس الاستهلاك في عداد قانوني = حوالي 342.5 جنيه
                  </div>
                  <br />
                </div>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">كيف أتجنب الوصول للشريحة السابعة؟</div>
              <div className="info-section-body">
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>الشريحة السابعة بدون دعم</h2>
                  </u>
                  <p>
                    الشريحة السابعة (أكثر من 1000 كيلووات) لا تحصل على أي دعم وسعرها 230 قرش.
                    للبقاء تحت 1000 كيلووات:
                  </p>
                  <div className="p-3 mb-2 bg-info text-black">
                    • قلل استخدام المكيف لـ 4-5 ساعات يومياً فقط
                    <br />
                    • استخدم سخان غاز بدل الكهرباء
                    <br />
                    • استبدل اللمبات العادية بـ LED
                    <br />
                    • افصل الأجهزة من الكهرباء عند عدم الاستخدام
                    <br />
                    • استخدم المراوح بدلاً من المكيف عندما يكون الجو معتدلاً
                  </div>
                  <br />
                </div>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">ماذا يحدث إذا لم أدفع الفاتورة في موعدها؟</div>
              <div className="info-section-body">
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>غرامة التأخير</h2>
                  </u>
                  <p>
                    حسب قرار جهاز تنظيم مرفق الكهرباء، يجب دفع الفاتورة خلال شهر من تاريخ
                    إصدارها. التأخير في السداد يترتب عليه:
                  </p>
                  <div className="p-3 mb-2 bg-warning text-black">
                    <strong>غرامة 7% من قيمة الفاتورة</strong>
                    <br/>                    مثال: فاتورة 300 جنيه × 7% = غرامة 21 جنيه
                    <br />
                    المبلغ الإجمالي المطلوب = 321 جنيه
                  </div>
                  <br />
                </div>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">كم يستهلك المكيف شهرياً؟</div>
              <div className="info-section-body">
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>استهلاك المكيفات</h2>
                  </u>
                  <p>
                    المكيف من أكثر الأجهزة استهلاكاً للكهرباء:
                  </p>
                  <div className="p-3 mb-2 bg-info text-black">
                    <strong>مكيف 1.5 حصان (6 ساعات يومياً):</strong>
                    <br />
                    1200 واط × 6 ساعات × 30 يوم = 216 كيلووات
                    <br />
                    التكلفة: حوالي 225-250 جنيه شهرياً
                    <br/>                    <strong>مكيف 2.25 حصان (6 ساعات يومياً):</strong>
                    <br />
                    1800 واط × 6 ساعات × 30 يوم = 324 كيلووات
                    <br />
                    التكلفة: حوالي 350-380 جنيه شهرياً
                  </div>
                  <br />
                </div>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">كيف أحسب استهلاك أي جهاز؟</div>
              <div className="info-section-body">
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>المعادلة الأساسية</h2>
                  </u>
                  <p>
                    الاستهلاك الشهري (كيلووات) = (القدرة بالواط × الساعات يومياً ÷ 1000) × 30
                  </p>
                  <br />
                </div>
                <hr />
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>مثال: الثلاجة</h2>
                  </u>
                  <p>
                    ثلاجة نوفروست 180 واط تعمل 24 ساعة:
                  </p>
                  <div className="p-3 mb-2 bg-info text-black">
                    (180 × 24 ÷ 1000) × 30 = 129.6 كيلووات شهرياً
                    <br />
                    التكلفة: 129.6 × 0.95 = <strong>123 جنيه تقريباً</strong>
                  </div>
                  <br />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default ElectricityCalculator;